import React from 'react';
import './App.css';
import MainRoutes from './routes/Routes';
import { PayPalScriptProvider } from "@paypal/react-paypal-js";

function App() {
  return (<React.Fragment>
    <PayPalScriptProvider options={{ "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID, currency: "GBP" }}>
      <MainRoutes />
    </PayPalScriptProvider>
  </React.Fragment>);
}

export default App;